import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button"];
  static values = { copiedText: String };

  declare readonly sourceTarget: HTMLTextAreaElement | HTMLInputElement;
  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly copiedTextValue: string;
  declare readonly hasCopiedTextValue: boolean;

  async copy() {
    const text = this.sourceTarget.value;
    if (!text) return;

    this.sourceTarget.select();
    this.sourceTarget.setSelectionRange(0, text.length);

    try {
      await navigator.clipboard.writeText(text);
    } catch (_error) {
      document.execCommand("copy");
    }

    this.showCopiedState();
  }

  private showCopiedState() {
    const originalText = this.buttonTarget.textContent || "";
    this.buttonTarget.textContent = this.hasCopiedTextValue ? this.copiedTextValue : "Copied";

    window.setTimeout(() => {
      this.buttonTarget.textContent = originalText;
    }, 1500);
  }
}
